import { Inject } from '@odinjs/odin';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';
import './flacc-pain-scale-controller.css';
import { Endpoint } from '../../../constants/endpoints';
import { FlaccPainScaleAliases, FragmentNames } from '../../../codegen';

@Controller({ fragment: FragmentNames.FLACC_PAIN_SCALE })
class FlaccPainScaleController extends BaseController {

  @Inject(FlaccPainScaleAliases.REFERENCE_MODAL)
  panelLoaderModalApi!: PanelAPI;

  @Inject(FlaccPainScaleAliases.FACE_RADIO_GROUP)
  faceRadioGroupApi!: RadioGroupAPI;

  @Inject(FlaccPainScaleAliases.LEGS_RADIO_GROUP)
  legsRadioGroupApi!: RadioGroupAPI;

  @Inject(FlaccPainScaleAliases.CRYING_RADIO_GROUP)
  cryingRadioGroupApi!: RadioGroupAPI;

  @Inject(FlaccPainScaleAliases.ACTIVITY_RADIO_GROUP)
  activityRadioGroupApi!: RadioGroupAPI;

  @Inject(FlaccPainScaleAliases.CONSOLATION_RADIO_GROUP)
  consolationRadioGroupApi!: RadioGroupAPI;

  @OnMount({target: FlaccPainScaleAliases.FACE_RADIO_GROUP})
  onMountFaceForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.flaccPainScaleRadioGroup(335927, radioGroup);
  }

  @OnMount({target: FlaccPainScaleAliases.LEGS_RADIO_GROUP})
  onMountLegsForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.flaccPainScaleRadioGroup(335926, radioGroup);
  }

  @OnMount({target: FlaccPainScaleAliases.CRYING_RADIO_GROUP})
  onMountCryingForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.flaccPainScaleRadioGroup(335929, radioGroup);
  }

  @OnMount({target: FlaccPainScaleAliases.ACTIVITY_RADIO_GROUP})
  onMountActivityForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.flaccPainScaleRadioGroup(335928, radioGroup);
  }

  @OnMount({target: FlaccPainScaleAliases.CONSOLATION_RADIO_GROUP})
  onMountConsolationForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.flaccPainScaleRadioGroup(335930, radioGroup);
  }

  @OnClose({ target: FlaccPainScaleAliases.MODAL_PAIN_SCALE_REFERENCE})
  onCloseModal(): void {
    this.panelLoaderModalApi.setVisible(false);
  }

  @OnClick({ target: FlaccPainScaleAliases.REFERENCE_LINK})
  onClickReference(): void {
    this.panelLoaderModalApi.setVisible(true);
  }

  @OnCancel({ target: FlaccPainScaleAliases.CONSOLATION_FORM})
  onClickCancel(): void {
    ModalService.close('flacc-pain-scale');
  }

  @OnBeforeSubmit({ target: FlaccPainScaleAliases.CONSOLATION_FORM})
  onBeforeSubmitForm(): void {
    const setPainScaleValue = this.context.get('setPainScaleValue');
    setPainScaleValue(Number(this.faceRadioGroupApi?.getValue()?.value)
                      + Number(this.legsRadioGroupApi?.getValue()?.value)
                      + Number(this.cryingRadioGroupApi?.getValue()?.value)
                      + Number(this.activityRadioGroupApi?.getValue()?.value)
                      + Number(this.consolationRadioGroupApi?.getValue()?.value));

    ModalService.close('flacc-pain-scale');
  }

  flaccPainScaleRadioGroup(expressionId:number, radioGroup:RadioGroupAPI) :void{
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, {encounterId, expressionId, patientId})
      .then(response => {
        if(response) {
          const responseBody = response.body as SelectableItem[];
          radioGroup.setData(responseBody);
          radioGroup.setValue(responseBody[0]);
        }
      });
  }
}
export default FlaccPainScaleController;
